import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_sweater_custom: FaireProductEntity = {
  token: "apparel-sweater-custom",
  type: "product",
  name: "Custom Text Crewneck",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fa2cce05dc57c50def71866a6c23eec758d96fa62d43dfbae5ac9bd504113b3f.jpeg",
  priceDollars: 38,
  msrpDollars: 75,
  freeShipping: false,
  weight: 1,
  dimensions: {
    width: 14,
    height: 18,
    depth: 2,
  },
  description:
    "Varsity-style arc text crewneck. Customize with store name or message.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "sweater", "custom", "embroidered"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
